import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLineInView } from "../motion/Reveal";
import { IMAGES } from "../../data/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="about" ref={ref} className="relative py-24 md:py-36 border-t border-white/10">
      <div className="container-editorial grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Text */}
        <div className="lg:col-span-6">
          <Reveal>
            <p className="overline mb-6">01 — Introduction</p>
          </Reveal>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
            <MaskLineInView>More Than</MaskLineInView>
            <MaskLineInView delay={0.1}>
              <span className="italic text-gold">Trading.</span>
            </MaskLineInView>
          </h2>

          <Reveal delay={0.15}>
            <p className="mt-8 text-lg text-ash leading-relaxed max-w-xl">
              Trading is not only about charts, numbers, and financial results. It is also about
              emotional control, patience, decision-making, responsibility, and self-awareness.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 text-lg text-ash leading-relaxed max-w-xl">
              For Dakka, trading is a reflection of life. Every decision requires clarity. Every
              loss offers a lesson. Every opportunity demands preparation. Beyond financial
              markets, his story is about becoming more intentional, disciplined, and grounded.
            </p>
          </Reveal>

          <Reveal delay={0.35}>
            <div className="mt-10 flex items-center gap-6">
              <span className="font-serif text-5xl text-gold">“</span>
              <p className="font-serif italic text-2xl text-bone leading-snug max-w-md">
                Every loss offers a lesson. Every opportunity demands preparation.
              </p>
            </div>
          </Reveal>
        </div>

        {/* Image — displayed in FULL, no crop */}
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal y={60}>
            <motion.div style={{ y }} className="relative overflow-hidden border border-white/10 bg-ink">
              <img
                src={IMAGES.fullMoment}
                alt="Dakka Gabriel Rey"
                className="w-full h-auto object-contain contrast-[1.06] saturate-[1.1] brightness-[1.03]"
                loading="lazy"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <p className="font-mono text-xs text-bone/80 tracking-widest">THE PERSON BEHIND THE PROCESS</p>
              </div>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
